import { createSelector } from 'reselect'
// tslint:disable-next-line: max-line-length
import IdentificationStep from '../components/organisms/background-check/usa/identification-step'
import { validators as sharedValidators } from '../utilities/validators'

const getNeedsLicenseInfo = state => state.needsLicenseInfo

const getExperiments = state => state.experiments

export const getValidator = createSelector(
  getNeedsLicenseInfo,
  getExperiments,
  needsLicenseInfo => {
    let validator
    if (needsLicenseInfo) {
      validator = Object.assign(IdentificationStep.checkrValidators, {})
    } else {
      validator = Object.assign(IdentificationStep.noLicenseValidators, {})
    }

    validator.confirmSsn = sharedValidators.confirmSsn

    return validator
  }
)
